module.exports = __webpack_public_path__ + "img/bg_people_home_03.1dc71ca7.png";